import { useEffect, useState } from 'react'
import { dataLayerPush } from '@specs/helpers'
import { CART_LIMIT } from '@helpers/arToysHelpers'
import { addToysToCart, checkToyInstanceIdIsInCart, checkToyIsInCart, getToysInCartFromCookies, getToysStoreItemsInCartFromCookies, ICartItemToys } from '@services/store/helpers/cart'
import { useShowToast } from '@hooks/useShowToast'
import { storeItem, toy } from '@specs/specs'

interface IArgs {
    toyId: toy['id']
    instanceId?: number
}

const checkIsInCart = ({ toyId, instanceId }: IArgs) => {
    return typeof instanceId === 'number' ? checkToyInstanceIdIsInCart(toyId, instanceId) : checkToyIsInCart(toyId)
}

export const useToysCart = ({ toyId, instanceId }: IArgs) => {
    const { showToast } = useShowToast()
    const [isInCartState, setIsInCartState] = useState(checkIsInCart({ toyId, instanceId }))

    useEffect(() => {
        const listener = () => {
            setIsInCartState(checkIsInCart({ toyId, instanceId }))
        }
        document.addEventListener('cart_event', listener as EventListener)

        return () => {
            document.removeEventListener('cart_event', listener as EventListener)
        }
    }, [])

    const addToCartHandler = (
        storeItem: Omit<storeItem, 'instanceid'> & {
            instanceid: number
        },
    ): boolean => {
        if (getToysStoreItemsInCartFromCookies().length >= CART_LIMIT) {
            showToast({
                variant: 'error',
                text: 'cart.is.full',
            })
            return false
        }
        const list = getToysInCartFromCookies()

        const data: ICartItemToys[] = storeItem?.toyid
            ? [
                  ...list,
                  {
                      toyId: storeItem.toyid,
                      figures: [
                          {
                              toyId: storeItem.toyid,
                              instanceId: storeItem.instanceid,
                              price: storeItem.price,
                              storeItemId: storeItem.id,
                              currency: storeItem.currency,
                              digitalDropId: storeItem.digitalDropId,
                          },
                      ],
                  },
              ]
            : list

        dataLayerPush('add_to_cart', [
            {
                item_name: `Toy, id: ${storeItem.toyid}`,
                item_id: storeItem.toyid!,
                item_category: 'Toy',
                item_variant: storeItem.currency === 'GOLD' ? 'payment_gold' : 'payment_ruby',
                quantity: 1,
                price: storeItem.price,
                item_brand: 'ArToys',
            },
        ])

        addToysToCart(data)
        return true
    }

    return { addToCartHandler, isInCartState, setIsInCartState }
}
